/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_Asset_LabelInputs */

const en_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset`)
};

const de_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermögenswert`)
};

const pt_br2_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativo`)
};

const tr_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varlık`)
};

const zh_cn2_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资产`)
};

const zh_hk2_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資產`)
};

const ko_kr2_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자산`)
};

const ru_ru2_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Актив`)
};

const es_419_onboarding_v1_fund_asset_label = /** @type {(inputs: Onboarding_V1_Fund_Asset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activo`)
};

/**
* | output |
* | --- |
* | "Asset" |
*
* @param {Onboarding_V1_Fund_Asset_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_asset_label = /** @type {((inputs?: Onboarding_V1_Fund_Asset_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_Asset_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_asset_label(inputs)
	if (locale === "de") return de_onboarding_v1_fund_asset_label(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_asset_label(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_asset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_asset_label(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_asset_label(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_asset_label(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_asset_label(inputs)
	return es_419_onboarding_v1_fund_asset_label(inputs)
});